import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
import { getIsAnyPanelVisible } from '../DeviationPage/redux/selectors';
import { getIsBackgroundsPopupOpen } from '../DeviationBackground/redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isAnyDialogOpen: getIsAnyPanelVisible(state) || getIsBackgroundsPopupOpen(state),
    isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ActionBar.container.js.map